import { Separator, Skeleton } from '@/_components';
import { CardContainer, FormLayout, ImageTextHeader, PageHeaderCtrlContainer } from '@/_containers';
import { PageHeaderContainer } from '@/_containers/headers/page/page-header-container';
import { LogoWithSelectorLoading } from '@/_containers/layout/selector-with-avatar/selector-with-avatar-loader';

export function HeaderLoading({ editable }: { editable?: boolean }) {
  return (
    <CardContainer className="pb-2">
      <section className="flex flex-1 items-center justify-center gap-4">
        <aside className="absolute top-7 left-7">
          <Skeleton className="w-20" />
        </aside>

        <div className="mt-8">
          <PageHeaderContainer>
            <ImageTextHeader
              imageSlot={<Skeleton className="h-24 w-[7.84rem] rounded-xl" />}
              primarySlot={<Skeleton className="mt-2 h-7 w-36" />}
              secondarySlot={<Skeleton className="mt-1 h-5 w-28" />}
              tertiarySlot={
                <PageHeaderCtrlContainer className="ml-0">
                  <Skeleton className="h-6 w-24" />
                </PageHeaderCtrlContainer>
              }
            />
          </PageHeaderContainer>
        </div>
      </section>

      {editable && (
        <>
          <Separator className="bg-outline/40 mt-9 dark:bg-gray-600/40" />
          <FormLayout>
            <LogoWithSelectorLoading className="lg:items-center" avatarContainerClassName="lg:border-none mb-0" />

            <LogoWithSelectorLoading className="lg:items-center" avatarContainerClassName="lg:border-none mb-0" />

            <LogoWithSelectorLoading className="lg:items-center" avatarContainerClassName="lg:border-none mb-0" />

            <LogoWithSelectorLoading className="lg:items-center" avatarContainerClassName="lg:border-none mb-0" />
          </FormLayout>
        </>
      )}
    </CardContainer>
  );
}
